import { loggedFetch } from "../utils/centralized-logging/loggedFetch";

const getParseApiBaseUrl = () => {
  const base = process.env.REACT_APP_API_URL_TREE_SCALE || "";
  return base.endsWith("/") ? base : base + "/";
};

const linkDepagoPath = "mbp-pagoenlinea/parse/classes/linkdepago";

export const notificacionPagoFactura = async (request, _productType) => {
  const userKey = process.env.REACT_APP_USER_KEY_PAGO_SERVICE || "";
  const url = `${getParseApiBaseUrl()}${linkDepagoPath}${request}`;

  const res = await loggedFetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Parse-Application-Id": "messagebrokerApp",
      parseRestApiKey: "weNFQQz70jfHScxs3Y9R5ndm5PCeraav",
      parseMasterKey: "HqLjKl7c2W",
      user_key: userKey,
    },
  });

  return res.json().catch(() => ({}));
};
